var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 18,
    fill: "#3077FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 43C47.6281 43 53 37.4043 53 30.5C53 23.5957 47.6281 18 41 18C34.3719 18 29 23.5957 29 30.5C29 37.4043 34.3719 43 41 43ZM49.4 46.125H47.8344C45.7531 47.1211 43.4375 47.6875 41 47.6875C38.5625 47.6875 36.2563 47.1211 34.1656 46.125H32.6C25.6437 46.125 20 52.0039 20 59.25V63.3125C20 65.9004 22.0156 68 24.5 68H57.5C59.9844 68 62 65.9004 62 63.3125V59.25C62 52.0039 56.3563 46.125 49.4 46.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudys);
export default __webpack_public_path__ + "static/media/studys_.b461ba4a9d47cd08bccad5ace14f0854.svg";
export { ForwardRef as ReactComponent };